import axios from "axios";
import { errorToast } from "../../../react-toastfiy/toast";

class InvoiceService {
  getInvoiceNo = (formData) => {

    return axios({
      method: "post",
      url: `accounting/next-invoice-number`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };



  getCreatedInvoiceList = (formData) => {

    return axios({
      method: "post",
      url: `accounting/invoice-list`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  CreateInvoice = (formData) => {
    return axios({
      method: "post",
      url: `accounting/create-or-update-invoice`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  GenerateInvoiceData = (formData) => {
    return axios({
      method: "post",
      url: `accounting/generate-invoice-data`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

  DeleteInvoice = (formData) => {
    return axios({
      method: "post",
      url: `accounting/delete-invoice`,
      data: formData,
    })
      .then((response) => {
        return response.data;
      })
      .catch(function (error) {
        errorToast(error?.msg);
        console.log(error);
      });
  };

}
export default new InvoiceService();
